import types from './types';
import actions from './actions';
import reducers from './reducers';
import services from './services';

const categories = {
  types,
  actions,
  reducers,
  services,
}

export default categories;